import { getClient } from '@zg-rentals/ts-client-http-client';

export const rentalManagerClient = getClient().extend({
  prefixUrl: __DEV__ ? __API__ : '/',
});
